export const shouldShowStateField = (country: string): boolean => !!(country && country === 'US');
